import { render } from "./whatsappBotList.vue?vue&type=template&id=234249d3&scoped=true"
import script from "./whatsappBotList.vue?vue&type=script&lang=js"
export * from "./whatsappBotList.vue?vue&type=script&lang=js"

import "./whatsappBotList.vue?vue&type=style&index=0&id=234249d3&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234249d3"]])

export default __exports__